import { Nullable } from './common';

export const MAP_TYPES = {
  BUYING: 'BUYING',
  GAP: 'GAP',
  NORMAL: 'NORMAL',
  BRANCH: 'BRANCH',
} as const;
export type MAP_TYPES = typeof MAP_TYPES[keyof typeof MAP_TYPES];

export interface MapFilterBase {
  zoom: number;
  latitude: number;
  longitude: number;
  west: number;
  north: number;
  east: number;
  south: number;
}

export interface MarkerBase {
  complexId: number;
  bldNm: string;
  center: LatLng;
  count: number;
  districtName: Nullable<string>;
}

export interface LatLng {
  latitude: number;
  longitude: number;
}
